// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2erg2","top":"styles_top__2ez7t","left":"styles_left__1P9oe","description":"styles_description__3itEA"};